var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Github 1",
    clipPath: "url(#clip0_478_4496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.133 8.91605L8.058 8.16605C7.596 7.99905 7.105 8.33405 7.092 8.82505L7.04 10.758C6.529 11.388 6.231 12.12 6.231 12.905C6.231 15.142 7.843 16.954 9.874 17.096C8.983 18.466 9 20.087 9 20.087V20.803C7.992 20.392 6.078 19.435 4.773 17.688C3.701 16.253 3 14.334 3 12.308C3 9.63005 4.028 7.51605 5.412 6.02005C7.239 4.04705 9.753 3.12305 12 3.12305C14.247 3.12305 16.761 4.04705 18.588 6.02005C19.972 7.51605 21 9.63005 21 12.308C21 14.335 20.299 16.253 19.227 17.688C17.922 19.435 16.008 20.392 15 20.803V20.087C15 20.087 15.017 18.466 14.126 17.096C16.157 16.954 17.769 15.142 17.769 12.905C17.769 12.12 17.47 11.388 16.96 10.758L16.908 8.82605C16.895 8.33505 16.404 8.00005 15.942 8.16705L13.867 8.91705C13.281 8.77005 12.654 8.68705 12 8.68705C11.346 8.68705 10.719 8.77005 10.133 8.91605Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_4496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.123047)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.4bb03729f7408c687e72e90fb8909b5a.svg";
export { ForwardRef as ReactComponent };